import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { MenuItem, MenuComponent } from '@ui-lib/components';
import { Observable, map } from 'rxjs';
import { UserInformationService } from '../../../core/services/user/user-information.service';
import { MENU_ITEMS } from './menu.const';
import { NavigationMenuEnum } from './model/navigation-menu.enum';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'rrp-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet, AsyncPipe, HeaderComponent, MenuComponent],
})
export class LayoutComponent {
  private readonly userInformationService = inject(UserInformationService);

  protected readonly MENU_ITEMS = MENU_ITEMS;

  public getFilteredMenu(): Observable<MenuItem<NavigationMenuEnum>[]> {
    return this.userInformationService.userPermissions$.pipe(
      map((permissions) => {
        return this.MENU_ITEMS.filter((item) => {
          if (item.requiredPermission) {
            return permissions.includes(item.requiredPermission);
          }
          return true;
        });
      }),
    );
  }
}
